module.exports = __webpack_public_path__ + "static/media/Peter.d73735a5.jpg";